

let data = {

}

let fn = {
    // 音频播放当前时间与总时长转换  秒转换成00:00
    setAudioTime:(time) => {
        var hours = parseInt(time / 3600);
        if (hours < 10) {
            hours = "0" + hours;
        }
        var minute = parseInt(time / 60);
        if (minute < 10) {
            minute = "0" + minute;
        }
        var second = parseInt(time % 60);
        if (second < 10) {
            second = "0" + second;
        }
        return hours + ":" + minute + ":" + second;
    },
    // 章节创建日期格式转换成年月日
    setCreatTime:(time) => {
        if( !time ) return false;
        time = time.replace(/\-/g, '/');
        var data = new Date(time);
        var year = data.getFullYear(),
        mon = data.getMonth()+1,
        day = data.getDate();
        if( mon < 10 ) {
            mon = "0" + mon;
        }
        if( day < 10 ) {
            day = "0" + day;
        }
        return year + "-" + mon + "-" + day;
    },
    // 去除前后空格
    trim: (str)=>{ 
        return str.replace(/(^\s*)|(\s*$)/g, ""); 
    }
}

let commins = {
    data,
    fn
}

export default commins;
